export default __webpack_public_path__ + "cbc369df4ffa876af13145a91679a00b.png";